import { render, staticRenderFns } from "./messageTempManagement.vue?vue&type=template&id=7b4220b3&scoped=true&"
import script from "./messageTempManagement.vue?vue&type=script&lang=js&"
export * from "./messageTempManagement.vue?vue&type=script&lang=js&"
import style0 from "./messageTempManagement.vue?vue&type=style&index=0&id=7b4220b3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b4220b3",
  null
  
)

component.options.__file = "messageTempManagement.vue"
export default component.exports